export const queue = {
  type: {
    all: {
      title: 'Всем',
      description: 'Звонок поступает всем операторам.'
    },
    random: {
      title: 'Рандом',
      description: 'Звонок поступает случайному оператору.'
    }
  }
};
